export default {
  // Common operations
  'common.query': 'Query',
  'common.reset': 'Reset',
  'common.add': 'Add',
  'common.edit': 'Edit',
  'common.delete': 'Delete',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.export': 'Export',
  'common.import': 'Import',
  'common.select': 'Please select',
  'common.input': 'Please enter',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.enable': 'Enable',
  'common.disable': 'Disable',
  'common.status': 'Status',
  'common.operation': 'Operation',
  'common.required': 'This field is required',
  'common.collapse': 'Collapse',
  'common.expand': 'Expand',
  'common.addSuccess': 'Add Success',
  'common.updateSuccess': 'Update Success',
  'common.updateFail': 'Update Failed',
  'common.deleteSuccess': 'Delete Success',
  'common.startTime': 'Start Time',
  'common.endTime': 'End Time',
  'common.sort': 'Sort',
  'common.more': 'More',
'video.status': 'Status',
'video.sortDesc': 'Sort',
'video.orderBySort': 'Order by sort',
'video.more': 'More',
'video.operation': 'Operation',
  // Table related
  'table.index': 'Index',
  'table.id': 'ID',
  'table.createTime': 'Create Time',
  'table.updateTime': 'Update Time',
  'table.sort': 'Sort',
  'table.total': 'Total {total} items',
  'table.default': 'Default',
  'table.middle': 'Middle',
  'table.small': 'Compact',
  'table.columnDisplay': 'Column Display/Sort',
  'table.columnSortTip': 'Drag column name to sort',

  // Setting drawer related
  'setting.overallStyle': 'Overall Style Settings',
  'setting.darkMenu': 'Dark Menu Style',
  'setting.lightMenu': 'Light Menu Style',
  'setting.themeColor': 'Theme Color',
  'setting.navMode': 'Navigation Mode',
  'setting.sidebarNav': 'Sidebar Navigation',
  'setting.topNav': 'Top Navigation',
  'setting.contentWidth': 'Content Width',
  'setting.contentWidthTip': 'This setting only works with [Top Navigation]',
  'setting.fixed': 'Fixed',
  'setting.fluid': 'Fluid',
  'setting.fixedHeader': 'Fixed Header',
  'setting.fixedSidebar': 'Fixed Sidebar',
  'setting.hideFooter': 'Hide Footer',
  'setting.multiTab': 'Multi Tab Mode',
  'setting.tableStyle': 'Table General Style',
  'setting.tableSize': 'Table Size',
  'setting.showBorder': 'Show Border',
  'setting.otherSettings': 'Other Settings',
  'setting.colorWeak': 'Color Weak Mode',
  'setting.copySettings': 'Copy Settings',
  'setting.copySuccess': 'Copy Success',
  'setting.copyFailed': 'Copy Failed',

  // MultiTab related
  'tab.closeCurrent': 'Close Current Tab',
  'tab.closeRight': 'Close Right',
  'tab.closeLeft': 'Close Left',
  'tab.closeAll': 'Close All',
  'tab.lastTabCannotClose': 'This is the last tab and cannot be closed',
  'tab.noLeftTabs': 'No tabs on the left',
  'tab.noRightTabs': 'No tabs on the right',

  // Video related
  'video.videoName': 'Video Name',
  'video.videoNameIn': 'Video Name (Chinese)',
  'video.videoNameAr': 'Video Name (Arabic)',
  'video.videoNameEn': 'Video Name (English)',
  'video.videoNameCn': 'Video Name (French)',
  'video.isRelease': 'Release Status',
  'video.category': 'Category',
  'video.tag': 'Tag',
  'video.noTag': 'No Tag',
  'video.new': 'NEW',
  'video.hot': 'HOT',
  'video.premiere': 'Premiere',
  'video.exclusive': 'Exclusive',
  'video.enable': 'Enable',
  'video.disable': 'Disable',
  'video.edit': 'Edit',
  'video.add': 'Add',
  'video.coverUrlIn': 'Cover Image (Chinese)',
  'video.coverUrlEn': 'Cover Image (English)',
  'video.coverUrlCn': 'Cover Image (French)',
  'video.coverUrl': 'Cover Image (Arabic)',
  'video.totalNum': 'Total Episodes',
  'video.diamondPrice': 'Coins per Episode',
  'video.releaseTime': 'Release Time',
  'video.upload': 'Upload',
  'video.uploadImage': 'Please upload image',
  'video.uploadFailed': 'Upload failed, please try again',
  'video.confirmDelete': 'Confirm Delete Selected Data?',
  'video.confirmDeleteContent': 'Currently Selected ID:',
  'video.confirmExport': 'Confirm Export?',
  'video.confirmExportContent': 'This operation will export all data under current conditions, not selected data',
  'video.inputVideoNameIn': 'Please enter video name (Chinese)',
  'video.inputVideoNameEn': 'Please enter video name (English)',
  'video.inputVideoNameCn': 'Please enter video name (French)',
  'video.inputVideoName': 'Please enter video name (Arabic)',
  'video.videoNameRequired': 'Video name cannot be empty',
  'video.videoNameEnRequired': 'Video name (English) cannot be empty',
  'video.videoNameCnRequired': 'Video name (French) cannot be empty',
  'video.videoNameInRequired': 'Video name cannot be empty',
  'video.coverUrlRequired': 'Cover image cannot be empty',
  'video.coverUrlEnRequired': 'Cover image (English) cannot be empty',
  'video.coverUrlCnRequired': 'Cover image (French) cannot be empty',
  'video.coverUrlInRequired': 'Cover image cannot be empty',
  'video.totalNumRequired': 'Total episodes cannot be empty',
  'video.freeLimitNumRequired': 'Free episodes cannot be empty',
  'video.freeLimitNumExceed': 'Free episodes cannot exceed total episodes',
  'video.diamondPriceLessThanDiscount': 'Coins per episode cannot be less than discount price',
  'video.discountPriceGreaterThanDiamond': 'Discount price cannot be greater than coins per episode',
  'video.releaseTimeRequired': 'Please select release time',
  'video.releaseTimeBeforeNow': 'Release time cannot be earlier than current time',
  'video.introductionsMaxLength': 'Introduction cannot exceed 500 characters',
  'video.episodeManage': 'Episode Management',
  'video.performerList': 'Performer List',
  'video.inputTotalNum': 'Please enter total episodes',
  'video.selectTag': 'Please select tag',
  'video.no': 'No Tag',
  'video.selectCategory': 'Please select category',
  'video.freeLimitNum': 'Free Episodes Count',
  'video.freeSecond': 'Free Preview Seconds',
  'video.adUnlockEnabled': 'Third-party ad unlock',
  'video.adUnlockHint': 'Allow locked episodes in this drama to be unlocked by watching third-party ads. No ad binding is required.',
  'video.discountPrice': 'Discount Price per Episode',
  'video.introductionsIn': 'Introduction (Chinese)',
  'video.introductionsEn': 'Introduction (English)',
  'video.introductionsCn': 'Introduction (French)',
  'video.introductions': 'Introduction (Arabic)',
  'video.inputIntroductionsIn': 'Please enter introduction (Chinese)',
  'video.inputIntroductionsEn': 'Please enter introduction (English)',
  'video.inputIntroductionsCn': 'Please enter introduction (French)',
  'video.inputIntroductions': 'Please enter introduction (Arabic)',
  'video.exportFileName': 'Video',

  // Video performer related
  'videoPerformer.performerNameDe': 'Performer Name',
  'videoPerformer.performerNameEn': 'Performer Name (English)',
  'videoPerformer.performerNameFr': 'Performer Name (French)',
  'videoPerformer.performerName': 'Performer Name (Arabic)',
  'videoPerformer.performerAvatar': 'Performer Avatar',
  'videoPerformer.inputPerformerNameDe': 'Please enter performer name',
  'videoPerformer.inputPerformerNameEn': 'Please enter performer name (English)',
  'videoPerformer.inputPerformerNameFr': 'Please enter performer name (French)',
  'videoPerformer.inputPerformerName': 'Please enter performer name (Arabic)',
  'videoPerformer.inputSort': 'Please enter sort',
  'videoPerformer.performerNameDeRequired': 'Performer name cannot be empty',
  'videoPerformer.performerNameEnRequired': 'Performer name (English) cannot be empty',
  'videoPerformer.performerNameFrRequired': 'Performer name (French) cannot be empty',
  'videoPerformer.performerNameRequired': 'Performer name (Arabic) cannot be empty',
  'videoPerformer.performerAvatarRequired': 'Performer avatar cannot be empty',
  'videoPerformer.confirmDelete': 'Confirm Delete Selected Data?',
  'videoPerformer.confirmDeleteContent': 'Currently Selected ID:',
  'videoPerformer.confirmExport': 'Confirm Export?',
  'videoPerformer.confirmExportContent': 'This operation will export all data under current conditions, not selected data',
  'videoPerformer.exportFileName': 'Video Performer',

  // App image related
  'appImg.tagName': 'App Bottom Tab Name',
  'appImg.imgUrl': 'Click to Show Image',
  'appImg.imgUrlNo': 'Unclicked Image',
  'appImg.exportFileName': 'App Bottom Tab Image',

  // Barrage related
  'barrage.nickname': 'User Nickname',
  'barrage.videoName': 'Video Name',
  'barrage.serialNumber': 'Episode',
  'barrage.content': 'Barrage Content',
  'barrage.commentTime': 'Comment Time',
  'barrage.inputNickname': 'Please enter user nickname',
  'barrage.inputVideoName': 'Please enter video name',
  'barrage.inputContent': 'Please enter barrage content',
  'barrage.exportFileName': 'User Barrage',

  // Search term related
  'search.content': 'Search Term',
  'search.inputContent': 'Please enter',
  'search.exportFileName': 'Search Term',

  // Push related
  'push.title': 'Title',
  'push.titleEn': 'Title (English)',
  'push.content': 'Content',
  'push.contentEn': 'Content (English)',
  'push.toPage': 'Jump Page',
  'push.toUser': 'Push User',
  'push.sendTime': 'Send Time',
  'push.toPage1': 'Single Drama Details',
  'push.toPage2': 'Rewards Page',
  'push.toPage3': 'Most Trending',
  'push.toPage4': 'Episode List',
  'push.toUser1': 'All Site',
  'push.toUser2': 'Eligible Users',
  'push.toUser3': 'Weekly/Monthly/Yearly Subscribers',
  'push.toUser4': 'Users with Coin Purchase History',
  'push.exportFileName': 'Platform Push',

  // Sensitive words related
  'words.contents': 'Sensitive Word',
  'words.inputContents': 'Please enter sensitive word',
  'words.contentsLength': 'Sensitive word must be between 1 and 100 characters',
  'words.exportFileName': 'Sensitive Word',
  'words.importTitle': 'Import Sensitive Words',
  'words.uploading': 'Uploading...',
  'words.importDragText': 'Drag file here to upload',
  'words.importHint': 'Single file upload, or click to select a file',
  'words.downloadTemplate': 'Download Template',
  'words.importTemplateFileName': 'sensitive-words',

  // Video tag related
  'videoTag.tagTitleIn': 'Title Name (Chinese)',
  'videoTag.tagTitleEn': 'Title Name (English)',
  'videoTag.tagTitleCn': 'Title Name (French)',
  'videoTag.tagTitle': 'Title Name (Arabic)',
  'videoTag.sort': 'Sort (Asc)',
  'videoTag.isOpen': 'Enabled',
  'videoTag.inputTagTitleIn': 'Please enter title name (Chinese)',
  'videoTag.inputTagTitleEn': 'Please enter title name (English)',
  'videoTag.inputTagTitleCn': 'Please enter title name (French)',
  'videoTag.inputTagTitle': 'Please enter title name (Arabic)',
  'videoTag.inputSort': 'Please enter sort',
  'videoTag.tagTitleInRequired': 'Title name cannot be empty',
  'videoTag.tagTitleEnRequired': 'Title name (English) cannot be empty',
  'videoTag.tagTitleCnRequired': 'Title name (French) cannot be empty',
  'videoTag.tagTitleRequired': 'Title name (Arabic) cannot be empty',
  'videoTag.tagTitleBmRequired': 'Title name (Spanish) cannot be empty',
  'videoTag.inputTagTitleBm': 'Please enter title name (Spanish)',
  'videoTag.inputTagTitleInRequired': 'Please enter title name (Japanese)',
  'videoTag.sortLabel': 'Sort',
  'videoTag.createTime': 'Create Time',
  'videoTag.operationSuccess': 'Operation Success',
  'videoTag.selectColor': 'Please select color',
  'videoTag.uploadBackground': 'Please upload background image',
  'videoTag.uploadFailed': 'Upload failed, please try again',
  'videoTag.uploadImage': 'Please upload image',
  'videoTag.exportFileName': 'Video Tag',

  // Gather related
  'gather.videoName': 'Video Name',
  'gather.video': 'Video',
  'gather.serialNumber': 'Current Episode',
  'gather.subtitle': 'Subtitle (Arabic)',
  'gather.subtitleEn': 'Subtitle (English)',
  'gather.subtitleCn': 'Subtitle (French)',
  'gather.subtitleIn': 'Subtitle',
  'gather.inputVideoName': 'Please select video',
  'gather.inputSerialNumber': 'Please enter current episode',
  'gather.upload': 'Upload',
  'gather.replace': 'Replace',
  'gather.preview': 'Preview',
  'gather.uploadVideo': 'Please upload video',
  'gather.uploadVttFile': 'Please upload vtt or srt file',
  'gather.invalidFileType': 'Invalid file type',
  'gather.waitUploadComplete': 'Please wait for the previous upload to complete',
  'gather.videoUrlRequired': 'Video cannot be empty',
  'gather.videoIdRequired': 'Video name cannot be empty',
  'gather.serialNumberRequired': 'Current episode cannot be empty',
  'gather.episode': 'Episode {num}',
  'gather.updateTime': 'Update Time',
  'gather.unknownSubtitleType': 'Unknown subtitle type',
  'gather.cosCredentialFailed': 'Failed to get COS credentials',
  'gather.uploadSuccess': 'Upload successful',
  'gather.saveFailed': 'Save failed',
  'gather.uploadFailed': 'Upload failed, please try again',
  'gather.exportFileName': 'Episode',

  // Route related
  'route.home': 'Home',
  'route.accountCenter': 'Account Center',
  'route.accountSettings': 'Account Settings',
  'route.smsSettings': 'SMS Settings',
  'route.jobLog': 'Job Log',
  'route.authUser': 'Assign User',
  'route.noticeEdit': 'Notice Edit',
  'route.genEdit': 'Edit Gen Config',

  // Guide related
  'guide.page': 'Guide Page',
  'guide.title': 'Title',
  'guide.content': 'Content',
  'guide.image': 'Image',
  'guide.sort': 'Sort',
  'guide.status': 'Status',
  'guide.createTime': 'Create Time',
  'guide.guidePage': 'Guide Page',
  'guide.selectStatus': 'Please select status',
  'guide.upload': 'Upload',
  'guide.inputSort': 'Please enter',
  'guide.sortRequired': 'Sort cannot be empty',
  'guide.bannerUrlRequired': 'Guide page URL cannot be empty',
  'guide.uploadImage': 'Please upload image',
  'guide.uploadFailed': 'Upload failed, please try again',
  'guide.add': 'Add',
  'guide.edit': 'Edit',
  'guide.exportFileName': 'Guide Page',
  'guide.operationSuccess': 'Operation Success',

  // Dashboard statistics related
  'dashboard.totalUserCount': 'Total Users',
  'dashboard.totalVipCount': 'Total VIP Users',
  'dashboard.totalRechargeAmount': 'Total Recharge Amount',
  'dashboard.today': 'Today',
  'dashboard.yesterday': 'Yesterday',
  'dashboard.last7Days': 'Last 7 Days',
  'dashboard.newUserCount': 'New Users',
  'dashboard.newSubUserCount': 'New Subordinate Users',
  'dashboard.rechargeCoinIncome': 'Total Recharge Coin Income',
  'dashboard.commissionIncome': 'Total Commission Income',
  'dashboard.vipIncome': 'Total VIP Purchase Income',
  'dashboard.episodeIncome': 'Total Episode Purchase Income',
  'dashboard.rechargeOrderCount': 'Subordinate User Recharge Orders',
  'dashboard.rechargeAmount': 'Subordinate User Recharge Amount',
  'dashboard.coinCount': 'Coins',
  'dashboard.order': 'Orders',
  'dashboard.userRechargeOverview': 'User Recharge Overview',
  'dashboard.rechargeIncome': 'Recharge Income',
  'dashboard.rechargeOrderNum': 'Recharge Orders',
  'dashboard.subUserRechargeOverview': 'Subordinate User Recharge Overview',
  'dashboard.commissionIncomeOverview': 'Commission Income Overview',
  'dashboard.vipSubscriptionOverview': 'VIP Subscription Overview',
  'dashboard.subscriptionIncome': 'Subscription Income',
  'dashboard.subscriptionCount': 'Subscriptions',
  'dashboard.dataValue': 'Data Value',
  'dashboard.rechargeCount': 'Recharge Count',
  'dashboard.peopleCount': 'People Count',
  'dashboard.totalCoinIncome': 'Total Coin Income',
  'dashboard.totalVipRechargeIncome': 'Total VIP Recharge Income',
  'dashboard.totalEpisodePurchaseIncome': 'Total Episode Purchase Income',
  'dashboard.paypay': 'PayPal',
  'dashboard.iosPurchase': 'iOS In-App Purchase',

  // Buy video related
  'buyVideo.nickname': 'Nickname',
  'buyVideo.serialNumber': 'Episode',
  'buyVideo.videoName': 'Video Name',
  'buyVideo.orderNo': 'Order No',
  'buyVideo.type': 'Purchase Type',
  'buyVideo.price': 'Price',
  'buyVideo.free': 'Free',
  'buyVideo.coin': 'Coin',
  'buyVideo.watchAd': 'Watch Ad',
  'buyVideo.detail': 'Detail',
  'buyVideo.inputNickname': 'Please enter nickname',
  'buyVideo.inputSerialNumber': 'Please enter',
  'buyVideo.selectVideo': 'Please select video',
  'buyVideo.userId': 'User ID',
  'buyVideo.videoId': 'Video ID',
  'buyVideo.gatherId': 'Episode ID',
  'buyVideo.typeLabel': 'Type 0-Free 1-Coin 2-Coin',
  'buyVideo.remark': 'Remark',
  'buyVideo.inputUserId': 'Please enter user ID',
  'buyVideo.inputVideoId': 'Please enter video ID',
  'buyVideo.inputGatherId': 'Please enter episode ID',
  'buyVideo.inputPrice': 'Please enter price',
  'buyVideo.inputContent': 'Please enter content',
  'buyVideo.userIdRequired': 'User ID cannot be empty',
  'buyVideo.videoIdRequired': 'Video ID cannot be empty',
  'buyVideo.gatherIdRequired': 'Episode ID cannot be empty',
  'buyVideo.typeRequired': 'Type cannot be empty',
  'buyVideo.purchaseDetail': 'Purchase Detail',
  'buyVideo.purchaseInfo': 'Purchase Info',
  'buyVideo.userNickname': 'User Nickname',
  'buyVideo.createTime': 'Create Time',
  'buyVideo.close': 'Close',
  'buyVideo.dataNotExist': 'Data does not exist',

  // Biz user related
  'bizUser.nickname': 'Nickname',
  'bizUser.email': 'Email',
  'bizUser.isVip': 'Is VIP',
  'bizUser.mobile': 'Mobile',
  'bizUser.userId': 'User ID',
  'bizUser.showId': 'Show ID',
  'bizUser.type': 'Type',
  'bizUser.phone': 'Phone',
  'bizUser.emailType': 'Email',
  'bizUser.thirdParty': 'Third Party',
  'bizUser.areaCode': 'Area Code',
  'bizUser.thirdPartyAccount': 'Third Party Account',
  'bizUser.invitationCode': 'Invitation Code',
  'bizUser.userStatus': 'User Status',
  'bizUser.isVipStatus': 'Is VIP',
  'bizUser.vipType': 'Type',
  'bizUser.weekVip': 'Week VIP',
  'bizUser.monthVip': 'Month VIP',
  'bizUser.yearVip': 'Year VIP',
  'bizUser.vipExpireTime': 'VIP Expire Time',
  'bizUser.coinCount': 'Coins',
  'bizUser.registerTime': 'Register Time',
  'bizUser.rechargeCoin': 'Recharge Coins',
  'bizUser.inputNickname': 'Please enter nickname',
  'bizUser.inputEmail': 'Please enter email',
  'bizUser.selectIsVip': 'Please select is VIP',
  'bizUser.inputMobile': 'Please enter mobile',
  'bizUser.yes': 'Yes',
  'bizUser.no': 'No',
  'bizUser.rechargeCoinAmount': 'Recharge Coin Amount',
  'bizUser.inputCoinAmount': 'Please enter',

  // App version related
  'appVersion.appType': 'APP Type',
  'appVersion.android': 'Android',
  'appVersion.ios': 'iOS',
  'appVersion.versionName': 'Version Name',
  'appVersion.versionCode': 'Version Code',
  'appVersion.packageSize': 'Package Size',
  'appVersion.updateUrlType': 'Update URL Type',
  'appVersion.internal': 'Internal',
  'appVersion.market': 'Other (App Market)',
  'appVersion.updateType': 'Update Type',
  'appVersion.hotUpdate': 'Hot Update',
  'appVersion.fullUpdate': 'Full Update',
  'appVersion.forceUpdate': 'Force Update',
  'appVersion.forceUpdateStatus': 'Force Update Status',
  'appVersion.canSkip': 'Can Skip',
  'appVersion.force': 'Force',
  'appVersion.downloadUrl': 'Download URL',
  'appVersion.updateNotes': 'Update Notes',
  'appVersion.notesZh': 'Update notes (Chinese)',
  'appVersion.notesEn': 'Update notes (English)',
  'appVersion.notesFr': 'Update notes (French)',
  'appVersion.notesAr': 'Update notes (Arabic)',
  'appVersion.notesEs': 'Update notes (Spanish)',
  'appVersion.inputVersionName': 'Please enter version name (15 chars)',
  'appVersion.inputVersionCode': 'Please enter version code',
  'appVersion.inputPackageSize': 'Please enter package size',
  'appVersion.inputMarketUrl': 'Please enter other (app market) URL',
  'appVersion.inputDownloadUrl': 'Please enter download URL',
  'appVersion.inputUpdateNotes': 'Please enter update notes',
  'appVersion.selectAppType': 'Please select',
  'appVersion.selectUpdateUrlType': 'Please select',
  'appVersion.selectUpdateType': 'Please select',
  'appVersion.selectForceUpdate': 'Please select',
  'appVersion.appTypeRequired': 'APP type cannot be empty',
  'appVersion.updateUrlTypeRequired': 'Update URL type cannot be empty',
  'appVersion.versionCodeRequired': 'Version code cannot be empty',
  'appVersion.updateTypeRequired': 'Update type cannot be empty',
  'appVersion.forceUpdateRequired': 'Force update status cannot be empty',
  'appVersion.downloadUrlRequired': 'Download URL cannot be empty',
  'appVersion.uploadApk': 'Upload APK',
  'appVersion.apkUploading': 'Uploading APK, please wait',
  'appVersion.uploadApkTip': 'Upload a local APK to the server; download URL and size (MB) will be filled in automatically',
  'appVersion.apkUploadFail': 'APK upload failed, no download URL returned',
  'appVersion.apkOnly': 'Only .apk files are allowed',
  'appVersion.apkUploadSuccess': 'APK uploaded, download URL filled in',
  'appVersion.apkNoDownloadDomain': 'Download domain (tencent.cos.download-url) not configured; COS default domain cannot serve APK files. Configure a custom domain and upload again',
  'appVersion.confirmDelete': 'Confirm Delete Selected Data?',
  'appVersion.confirmDeleteContent': 'Currently Selected ID:',
  'appVersion.selectDataToDelete': 'Please select data to delete',

  // Feedback related
  'feedback.userNickname': 'User Nickname',
  'feedback.contact': 'Contact',
  'feedback.processStatus': 'Process Status',
  'feedback.pending': 'Pending',
  'feedback.processed': 'Processed',
  'feedback.ignored': 'Ignored',
  'feedback.userId': 'User ID',
  'feedback.showId': 'Show ID',
  'feedback.content': 'Feedback Content',
  'feedback.images': 'Feedback Images',
  'feedback.processResult': 'Process Result',
  'feedback.inputUserNickname': 'Please enter user nickname',
  'feedback.inputContact': 'Please enter contact',
  'feedback.selectProcessStatus': 'Please select process status',
  'feedback.inputProcessResult': 'Please enter process result',
  'feedback.processStatusRequired': 'Process status cannot be empty',
  'feedback.process': 'Process',
  'feedback.confirmDelete': 'Confirm Delete Selected Data?',
  'feedback.confirmDeleteContent': 'Currently Selected ID:',

  // Cancel related
  'cancel.userNickname': 'User Nickname',
  'cancel.cancelReason': 'Cancel Reason',
  'cancel.auditStatus': 'Audit Status',
  'cancel.auditFailReason': 'Audit Fail Reason',
  'cancel.auditor': 'Auditor',
  'cancel.userId': 'User ID',
  'cancel.showId': 'Show ID',
  'cancel.pendingAudit': 'Pending Audit',
  'cancel.auditSuccess': 'Audit Success',
  'cancel.auditFailed': 'Audit Failed',
  'cancel.agree': 'Agree',
  'cancel.reject': 'Reject',
  'cancel.inputNickname': 'Please enter nickname',
  'cancel.inputCancelReason': 'Please enter cancel reason',
  'cancel.inputAuditFailReason': 'Please enter audit fail reason',
  'cancel.inputAuditor': 'Please enter auditor',
  'cancel.selectAuditStatus': 'Please select audit status',
  'cancel.cancelReasonRequired': 'Cancel reason cannot be empty',
  'cancel.auditStatusRequired': 'Audit status cannot be empty',
  'cancel.audit': 'Audit',
  'cancel.mobileRequired': 'Mobile cannot be empty',
  'cancel.mobileFormatError': 'Please enter valid mobile number',
  'cancel.exportFileName': 'User Cancel',

  // Account center related
  'account.tags': 'Tags',
  'account.newTag': 'New Tag',
  'account.article': 'Article',
  'account.app': 'App',
  'account.project': 'Project',
  'account.activeUser': 'Active User',
  'account.newUser': 'New User',
  'account.loadMore': 'Load More',
  'account.designLanguage': 'Design Language',
  'account.antFinancial': 'Ant Financial',
  'account.tenThousand': 'K',

  // Account settings related
  'accountSettings.baseSettings': 'Base Settings',
  'accountSettings.securitySettings': 'Security Settings',
  'accountSettings.nickname': 'Nickname',
  'accountSettings.mobile': 'Mobile',
  'accountSettings.email': 'Email',
  'accountSettings.sex': 'Gender',
  'accountSettings.male': 'Male',
  'accountSettings.female': 'Female',
  'accountSettings.inputNickname': 'Give yourself a name',
  'accountSettings.inputMobile': 'Please enter mobile number',
  'accountSettings.inputEmail': 'Please enter email',
  'accountSettings.nicknameRequired': 'Please enter nickname',
  'accountSettings.emailRequired': 'Email cannot be empty',
  'accountSettings.emailFormatError': 'Please enter valid email address',
  'accountSettings.mobileRequired': 'Mobile cannot be empty',
  'accountSettings.mobileFormatError': 'Please enter valid mobile number',
  'accountSettings.updateAvatar': 'Update Avatar',
  'accountSettings.selectImage': 'Select Image',
  'accountSettings.uploadImageWarning': 'Please upload image',
  'accountSettings.uploadSuccess': 'Upload Success',
  'accountSettings.uploadFailed': 'Upload failed, please try again',
  'accountSettings.uploadAvatarSuccess': 'Upload avatar success',
  'accountSettings.accountPassword': 'Account Password',
  'accountSettings.currentPasswordStrength': 'Current Password Strength',
  'accountSettings.strong': 'Strong',
  'accountSettings.oldPassword': 'Old Password',
  'accountSettings.newPassword': 'New Password',
  'accountSettings.confirmPassword': 'Confirm Password',
  'accountSettings.resetPassword': 'Reset Password',
  'accountSettings.inputOldPassword': 'Please enter old password',
  'accountSettings.inputNewPassword': 'Please enter new password',
  'accountSettings.confirmPasswordPlaceholder': 'Please confirm password',
  'accountSettings.passwordRequired': 'Password cannot be empty',
  'accountSettings.newPasswordRequired': 'Please enter new password',
  'accountSettings.newPasswordFormatError': 'Please enter 5-20 characters including letters, numbers or symbols (except spaces), and at least two types of letters, numbers and punctuation',
  'accountSettings.confirmPasswordRequired': 'Please enter new password again to confirm',
  'accountSettings.passwordMismatch': 'The two passwords do not match',
  'accountSettings.tip': 'Tip',
  'accountSettings.updateSuccess': 'Update Success',
  'accountSettings.saveFailed': 'Save failed, please try again',

  // Banner related
  'banner.sort': 'Sort',
  'banner.type': 'Type',
  'banner.bannerType': 'Banner',
  'banner.adType': 'Ad',
  'banner.jumpType': 'Jump Type',
  'banner.video': 'Video',
  'banner.externalLink': 'External Link',
  'banner.rechargePage': 'Recharge Page',
  'banner.signIn': 'Sign In',
  'banner.status': 'Status',
  'banner.bannerImage': 'Banner Image',
  'banner.bannerImageEn': 'Banner Image (English)',
  'banner.bannerImageCn': 'Banner Image (French)',
  'banner.bannerImageArabic': 'Banner Image (Arabic)',
  'banner.video': 'Video',
  'banner.videoEn': 'Video (English)',
  'banner.videoCn': 'Video (French)',
  'banner.videoArabic': 'Video (Arabic)',
  'banner.isJump': 'Is Jump',
  'banner.externalLinkUrl': 'External Link',
  'banner.selectVideo': 'Please select video',
  'banner.inputSort': 'Please enter sort',
  'banner.selectType': 'Please select',
  'banner.selectJumpType': 'Please select jump type',
  'banner.selectIsJump': 'Please select is jump',
  'banner.inputExternalLink': 'Please enter external link',
  'banner.uploadImage': 'Upload (Please upload 750px X 1000px image first)',
  'banner.upload': 'Upload',
  'banner.bannerVideoSecond': 'Banner Video Play Seconds',
  'banner.bannerDisplaySecond': 'Banner Display Seconds',
  'banner.videoStartSecond': 'Video Start Play Second',
  'banner.inputDisplaySecond': 'Please enter display seconds',
  'banner.inputStartSecond': 'Please enter start play seconds',
  'banner.inputValidSecond': 'Please enter valid play seconds (minimum 0)',
  'banner.inputValidStartSecond': 'Please enter valid start play seconds (minimum 0)',
  'banner.inputValidDisplaySecond': 'Please enter valid display seconds (minimum 0)',
  'banner.sortRequired': 'Sort cannot be empty',
  'banner.isJumpRequired': 'Is jump cannot be empty',
  'banner.linkUrlRequired': 'External link cannot be empty',
  'banner.bannerUrlRequired': 'Banner URL cannot be empty',
  'banner.uploadImageWarning': 'Please upload image',
  'banner.uploadFailed': 'Upload failed, please try again',
  'banner.operationSuccess': 'Operation Success',
  'banner.confirmDelete': 'Confirm Delete Selected Data?',
  'banner.confirmDeleteContent': 'Currently Selected ID:',
  'banner.confirmExport': 'Confirm Export?',
  'banner.confirmExportContent': 'This operation will export all data under current conditions, not selected data',
  'banner.exportFileName': 'Banner',

  // Mobile code related
  'mobileCode.areaCode': 'Area Code',
  'mobileCode.country': 'Country Name',
  'mobileCode.countryEn': 'Country Name (English)',
  'mobileCode.countryCn': 'Country Name (French)',
  'mobileCode.countryArabic': 'Country Name (Arabic)',
  'mobileCode.status': 'Status',
  'mobileCode.isCommonly': 'Is Commonly',
  'mobileCode.inputAreaCode': 'Please enter area code',
  'mobileCode.inputCountry': 'Please enter country name',
  'mobileCode.inputCountryEn': 'Please enter country name (English)',
  'mobileCode.inputCountryCn': 'Please enter country name (French)',
  'mobileCode.inputCountryArabic': 'Please enter country name (Arabic)',
  'mobileCode.areaCodeExample': 'Area Code (e.g. +86)',
  'mobileCode.inputAreaCodeExample': 'Please enter area code (e.g. +86)',
  'mobileCode.areaCodeRequired': 'Area code cannot be empty',
  'mobileCode.countryRequired': 'Arabic country name cannot be empty',
  'mobileCode.countryEnRequired': 'English country name cannot be empty',
  'mobileCode.countryCnRequired': 'French country name cannot be empty',
  'mobileCode.countryBmRequired': 'Spanish country name cannot be empty',
  'mobileCode.countryInRequired': 'Japanese country name cannot be empty',
  'mobileCode.confirmDelete': 'Confirm Delete Selected Data?',
  'mobileCode.confirmDeleteContent': 'Currently Selected ID:',
  'mobileCode.confirmExport': 'Confirm Export?',
  'mobileCode.confirmExportContent': 'This operation will export all data under current conditions, not selected data',
  'mobileCode.exportFileName': 'Mobile Code',
  'mobileCode.operationSuccess': 'Operation Success',

  // Problem related
  'problem.title': 'Title',
  'problem.titleEn': 'Title (English)',
  'problem.titleCn': 'Title (French)',
  'problem.titleArabic': 'Title (Arabic)',
  'problem.content': 'Content',
  'problem.contentEn': 'Content (English)',
  'problem.contentCn': 'Content (French)',
  'problem.contentArabic': 'Content (Arabic)',
  'problem.sort': 'Sort',
  'problem.status': 'Status',
  'problem.createTime': 'Create Time',
  'problem.sketch': 'Sketch',
  'problem.inputTitle': 'Please enter title',
  'problem.inputTitleEn': 'Please enter title (English)',
  'problem.inputTitleCn': 'Please enter title (French)',
  'problem.inputTitleArabic': 'Please enter title (Arabic)',
  'problem.inputSketch': 'Please enter sketch',
  'problem.inputSort': 'Please enter sort number',
  'problem.problemTypeIdRequired': 'Problem type cannot be empty',
  'problem.titleRequired': 'Title cannot be empty',
  'problem.sortRequired': 'Sort cannot be empty',
  'problem.confirmDelete': 'Confirm Delete Selected Data?',
  'problem.confirmDeleteContent': 'Currently Selected ID:',
  'problem.confirmStatus': 'Confirm',
  'problem.enable': 'Enable',
  'problem.disable': 'Disable',
  'problem.statusConfirm': ' type?',
  'problem.open': 'Open',
  'problem.close': 'Close',
  'problem.operationSuccess': 'Operation Success!',

  // Problem type related
  'problemType.id': 'ID',
  'problemType.title': 'Title',
  'problemType.remark': 'Remark',
  'problemType.displaySort': 'Display Sort',
  'problemType.status': 'Status',
  'problemType.createTime': 'Create Time',
  'problemType.inputTitle': 'Please enter title',
  'problemType.inputContent': 'Please enter content',
  'problemType.inputSort': 'Please enter sort number',
  'problemType.isOpen': 'Is Open',
  'problemType.normal': 'Normal',
  'problemType.disable': 'Disable',
  'problemType.titleRequired': 'Title cannot be empty',
  'problemType.displaySortRequired': 'Display sort cannot be empty',
  'problemType.confirmDelete': 'Confirm Delete Selected Data?',
  'problemType.confirmDeleteContent': 'Currently Selected ID:',
  'problemType.confirmExport': 'Confirm Export?',
  'problemType.confirmExportContent': 'This operation will export all data under current conditions, not selected data',
  'problemType.exportFileName': 'Problem Type',
  'problemType.operationSuccess': 'Operation Success!',

  // Publicize related
  'publicize.videoName': 'Video Name',
  'publicize.publicizeVideo': 'Publicize Video',
  'publicize.sort': 'Sort',
  'publicize.remark': 'Remark',
  'publicize.video': 'Video',
  'publicize.inputVideoName': 'Please enter video name',
  'publicize.selectVideo': 'Please select video',
  'publicize.inputSort': 'Please enter sort',
  'publicize.inputContent': 'Please enter content',
  'publicize.upload': 'Upload',
  'publicize.preview': 'Preview',
  'publicize.uploadVideoWarning': 'Please upload video',
  'publicize.videoIdRequired': 'Video ID cannot be empty',
  'publicize.confirmDelete': 'Confirm Delete Selected Data?',
  'publicize.confirmDeleteContent': 'Currently Selected ID:',
  'publicize.confirmExport': 'Confirm Export?',
  'publicize.confirmExportContent': 'This operation will export all data under current conditions, not selected data',
  'publicize.exportFileName': 'Video Publicize',

  // Recharge order related
  'recharge.nickName': 'Nick Name',
  'recharge.mobile': 'Mobile',
  'recharge.email': 'Email',
  'recharge.orderNo': 'Order No',
  'recharge.payNo': 'Pay No',
  'recharge.outTrandNo': 'Out Trade No',
  'recharge.rechargeDiamond': 'Recharge Diamond',
  'recharge.giveDiamond': 'Give Diamond',
  'recharge.payMoney': 'Pay Money ($)',
  'recharge.menuId': 'Menu ID',
  'recharge.payTime': 'Pay Time',
  'recharge.status': 'Status',
  'recharge.createTime': 'Create Time',
  'recharge.remark': 'Remark',
  'recharge.userId': 'User ID',
  'recharge.inputNickName': 'Please enter nick name',
  'recharge.inputMobile': 'Please enter mobile',
  'recharge.inputEmail': 'Please enter email',
  'recharge.inputOrderNo': 'Please enter order no',
  'recharge.inputPayNo': 'Please enter pay no',
  'recharge.inputOutTrandNo': 'Please enter out trade no',
  'recharge.inputRechargeDiamond': 'Please enter recharge diamond',
  'recharge.inputPayMoney': 'Please enter pay money',
  'recharge.inputMenuId': 'Please enter menu id',
  'recharge.inputContent': 'Please enter content',
  'recharge.inputUserId': 'Please enter user id',
  'recharge.pendingPay': 'Pending Pay',
  'recharge.paySuccess': 'Pay Success',
  'recharge.payFailed': 'Pay Failed',
  'recharge.statusLabel': 'Status 0-Pending Pay 1-Pay Success 2-Pay Failed',
  'recharge.userIdRequired': 'User ID cannot be empty',
  'recharge.orderNoRequired': 'Order No cannot be empty',
  'recharge.payMoneyRequired': 'Pay Money cannot be empty',
  'recharge.statusRequired': 'Status cannot be empty',
  'recharge.confirmDelete': 'Confirm Delete Selected Data?',
  'recharge.confirmDeleteContent': 'Currently Selected ID:',
  'recharge.confirmExport': 'Confirm Export?',
  'recharge.confirmExportContent': 'This operation will export all data under current conditions, not selected data',
  'recharge.exportFileName': 'Recharge Order',

  // Recharge menu related
  'rechargeMenu.rechargePrice': 'Recharge Price',
  'rechargeMenu.rechargeDiamond': 'Recharge Diamond',
  'rechargeMenu.giveDiamond': 'Give Diamond',
  'rechargeMenu.status': 'Status',
  'rechargeMenu.inputRechargePrice': 'Please enter recharge price',
  'rechargeMenu.inputRechargeDiamond': 'Please enter recharge diamond',
  'rechargeMenu.inputGiveDiamond': 'Please enter give diamond',
  'rechargeMenu.rechargePriceRequired': 'Recharge price cannot be empty',
  'rechargeMenu.rechargeDiamondRequired': 'Recharge diamond cannot be empty',
  'rechargeMenu.giveDiamondRequired': 'Give diamond cannot be empty',
  'rechargeMenu.confirmDelete': 'Confirm Delete Selected Data?',
  'rechargeMenu.confirmDeleteContent': 'Currently Selected ID:',
  'rechargeMenu.confirmExport': 'Confirm Export?',
  'rechargeMenu.confirmExportContent': 'This operation will export all data under current conditions, not selected data',
  'rechargeMenu.exportFileName': 'Recharge Menu',
  'rechargeMenu.operationSuccess': 'Operation Success',

  // Report forms related
  'reportForms.dateSelect': 'Date Select',
  'reportForms.today': 'Today',
  'reportForms.yesterday': 'Yesterday',
  'reportForms.last7Days': 'Last 7 Days',
  'reportForms.last30Days': 'Last 30 Days',
  'reportForms.totalUser': 'Total User',
  'reportForms.totalPay': 'Total Pay',
  'reportForms.noTotalPay': 'No Total Pay',
  'reportForms.vipTotal': 'Vip Total',
  'reportForms.activeNum': 'Active Num',
  'reportForms.silentNum': 'Silent Num',
  'reportForms.rechargeTrend': 'Recharge Trend',
  'reportForms.iosRechargeTrend': 'iOS Recharge Trend',
  'reportForms.paypalRechargeTrend': 'PayPal Recharge Trend',
  'reportForms.subscriptionTrend': 'Subscription Trend',
  'reportForms.iosVipRechargeTrend': 'iOS Vip Recharge Trend',
  'reportForms.paypalVipRechargeTrend': 'PayPal Vip Recharge Trend',
  'reportForms.shopifyVipRechargeTrend': 'Shopify Vip Recharge Trend',
  'reportForms.payTypeStatistics': 'Pay Type Statistics',
  'reportForms.payTypeTotalMoney': 'Pay Type Total Money',
  'reportForms.rechargeAreaRanking': 'Recharge Area Ranking',
  'reportForms.subscriptionAreaRanking': 'Subscription Area Ranking',
  'reportForms.dataValue': 'Data Value',
  'reportForms.source': 'Source',
  'reportForms.selectSource': 'Please select source',
  'reportForms.isVip': 'Is Vip',
  'reportForms.selectIsVip': 'Please select is vip',
  'reportForms.showId': 'Show ID',
  'reportForms.inputShowId': 'Please enter show ID',
  'reportForms.nickname': 'Nickname',
  'reportForms.inputNickname': 'Please enter nickname',
  'reportForms.collapse': 'Collapse',
  'reportForms.expand': 'Expand',
  'reportForms.userId': 'User ID',
  'reportForms.areaCode': 'Area Code',
  'reportForms.address': 'Address',
  'reportForms.type': 'Type',
  'reportForms.weekVip': 'Week Vip',
  'reportForms.monthVip': 'Month Vip',
  'reportForms.yearVip': 'Year Vip',
  'reportForms.vipExpireTime': 'Vip Expire Time',
  'reportForms.totalRecharge': 'Total Recharge',
  'reportForms.diamondBalance': 'Diamond Balance',
  'reportForms.activity': 'Activity',
  'reportForms.active': 'Active',
  'reportForms.silent': 'Silent',
  'reportForms.setVipExpireTime': 'Set Vip Expire Time',
  'reportForms.videoName': 'Video Name',
  'reportForms.inputVideoName': 'Please enter video name',
  'reportForms.cover': 'Cover',
  'reportForms.episodeCount': 'Episode Count',
  'reportForms.playCount': 'Play Count',
  'reportForms.collectTotal': 'Collect Total',
  'reportForms.totalIncome': 'Total Income',
  'reportForms.completionRate': 'Completion Rate',
  'reportForms.detail': 'Detail',
  'reportForms.vipExpireTimeLabel': 'Vip Expire Time',
  'reportForms.edit': 'Edit',
  'reportForms.close': 'Close',
  'reportForms.updateFailed': 'Update failed, please try again',
  'reportForms.detailNotImplemented': 'Detail function not implemented',
  'reportForms.userInfoExportFileName': 'User Info',
  'reportForms.videoReportExportFileName': 'Video Report',
  'reportForms.confirmDelete': 'Confirm Delete Selected Data?',
  'reportForms.confirmDeleteContent': 'Currently Selected ID:',
  'reportForms.confirmExport': 'Confirm Export?',
  'reportForms.confirmExportContent': 'This operation will export all data under current conditions, not selected data',
  'reportForms.operationSuccess': 'Operation Success',
  'reportForms.deleteSuccess': 'Delete Success',
  'reportForms.email': 'Email',
  'reportForms.mobile': 'Mobile',
  'reportForms.emailSource': 'Email',
  'reportForms.mobileSource': 'Mobile',
  'reportForms.thirdPartyLogin': 'Third Party Login',

  // Reward related
  'reward.inviteNum': 'Invite Num',
  'reward.rewardNum': 'Reward Num',
  'reward.rewardType': 'Reward Type',
  'reward.rewardValue': 'Reward Value (Vip: Days, Diamond: Count)',
  'reward.giveDiamond': 'Give Diamond',
  'reward.giveVip': 'Give Vip',
  'reward.inputInviteNum': 'Please enter invite num',
  'reward.inputRewardNum': 'Please enter reward num',
  'reward.selectRewardType': 'Please select reward type',
  'reward.inviteNumRequired': 'Please enter invite num',
  'reward.inviteNumMin': 'Invite num must be greater than 0',
  'reward.confirmDelete': 'Confirm Delete Selected Data?',
  'reward.confirmDeleteContent': 'Currently Selected ID:',
  'reward.confirmExport': 'Confirm Export?',
  'reward.confirmExportContent': 'This operation will export all data under current conditions, not selected data',
  'reward.exportFileName': 'Invite User Reward Config',

  // Sign config related
  'signConfig.days': 'Days',
  'signConfig.goldNum': 'Gold Num',
  'signConfig.createTime': 'Create Time',
  'signConfig.inputDays': 'Please enter days',
  'signConfig.inputGoldNum': 'Please enter gold num',
  'signConfig.daysRequired': 'Days cannot be empty',
  'signConfig.goldNumRequired': 'Gold num cannot be empty',
  'signConfig.confirmDelete': 'Confirm Delete Selected Data?',
  'signConfig.confirmDeleteContent': 'Currently Selected ID:',
  'signConfig.confirmExport': 'Confirm Export?',
  'signConfig.confirmExportContent': 'This operation will export all data under current conditions, not selected data',
  'signConfig.exportFileName': 'Sign Config',

  // System related - common
  'system.userName': 'User Name',
  'system.phoneNumber': 'Phone Number',
  'system.email': 'Email',
  'system.password': 'Password',
  'system.addUser': 'Add User',
  'system.editUser': 'Edit User',
  'system.userNameRequired': 'User name cannot be empty',
  'system.nickNameRequired': 'Nick name cannot be empty',
  'system.deptRequired': 'Department cannot be empty',
  'system.passwordRequired': 'Password cannot be empty',
  'system.passwordLength': 'User password length must be between 5 and 20',
  'system.status': 'Status',
  'system.createTime': 'Create Time',
  'system.roleName': 'Role Name',
  'system.roleKey': 'Role Key',
  'system.menuName': 'Menu Name',
  'system.inputPlaceholder': 'Please enter',
  'system.selectPlaceholder': 'Please select',
  'system.selectStatus': 'Please select status',
  'system.collapse': 'Collapse',
  'system.expand': 'Expand',
  'system.enable': 'Enable',
  'system.disable': 'Disable',
  'system.confirmEnable': 'Confirm Enable',
  'system.confirmDisable': 'Confirm Disable',
  'system.user': 'User',
  'system.role': 'Role',
  'system.on': 'On',
  'system.off': 'Off',
  'system.yes': 'Yes',
  'system.no': 'No',
  'system.resetPassword': 'Reset Password',
  'system.newPassword': 'New Password',
  'system.confirmPassword': 'Confirm Password',
  'system.inputNewPassword': 'Please enter new password',
  'system.inputConfirmPassword': 'Please confirm password',
  'system.newPasswordRequired': 'Please enter new password',
  'system.passwordFormatError': 'Please enter 5-20 characters including letters, numbers or symbols (except spaces), and at least two of letters, numbers and punctuation',
  'system.confirmPasswordRequired': 'Please enter new password again to confirm',
  'system.passwordMismatch': 'The two passwords do not match',
  'system.resetPasswordSuccess': 'Reset Success',
  'system.assignRole': 'Assign Role',
  'system.roleSort': 'Sort',
  'system.menuPermission': 'Menu Permission',
  'system.expandCollapse': 'Expand/Collapse',
  'system.selectAllDeselectAll': 'Select All/Deselect All',
  'system.parentChildLink': 'Parent-Child Link',
  'system.parentChildLinkTip': 'You can switch mode only when the checked items are empty. You can click "Deselect All" and then switch again.',
  'system.roleKeyTip': 'Permission character defined in the controller, such as: @PreAuthorize(`@ss.hasRole(\'admin\')`)',
  'system.adminRoleInfo': 'Super administrator role information cannot be changed',
  'system.addRole': 'Add Role',
  'system.editRole': 'Edit Role',
  'system.roleNameRequired': 'Role name cannot be empty',
  'system.roleKeyRequired': 'Permission character cannot be empty',
  'system.roleSortRequired': 'Display order cannot be empty',
  'system.dataScope': 'Data Scope',
  'system.maskScope': 'Mask Scope',
  'system.import': 'Import',
  'system.export': 'Export',
  'system.confirmDelete': 'Confirm Delete Selected Data?',
  'system.confirmDeleteContent': 'Currently Selected ID:',
  'system.confirmExport': 'Confirm Export?',
  'system.confirmExportContent': 'This operation will export all data under current conditions, not selected data',
  'system.operationSuccess': 'Operation Success',
  'system.deleteSuccess': 'Delete Success',
  'system.exportSuccess': 'Export Success',
  'system.importSuccess': 'Import Success',
  'system.assignRoleSuccess': 'Assign Role Success',
  'system.dataScopeSuccess': 'Data Scope Set Success',
  'system.maskScopeSuccess': 'Mask Scope Set Success',
  'system.userId': 'User ID',
  'system.inputUserId': 'Please enter user ID',
  'system.remark': 'Remark',
  'system.nickName': 'Nick Name',
  'system.more': 'More',
  'system.roleId': 'Role ID',
  'system.assignUser': 'Assign User',
  'system.icon': 'Icon',
  'system.perms': 'Perms',
  'system.component': 'Component',
  'system.mainDirectory': 'Main Directory',
  'system.noticeId': 'Notice ID',
  'system.noticeTitle': 'Notice Title',
  'system.noticeType': 'Notice Type',
  'system.createBy': 'Created By',
  'system.addNotice': 'Add Notice',
  'system.editNotice': 'Edit Notice',
  'system.title': 'Title',
  'system.titleEn': 'Title (English)',
  'system.titleCn': 'Title (French)',
  'system.titleArabic': 'Title (Arabic)',
  'system.content': 'Content',
  'system.contentEn': 'Content (English)',
  'system.contentCn': 'Content (French)',
  'system.contentArabic': 'Content (Arabic)',
  'system.inputTitle': 'Please enter title',
  'system.inputTitleEn': 'Please enter title (English)',
  'system.inputTitleCn': 'Please enter title (French)',
  'system.inputTitleArabic': 'Please enter title (Arabic)',
  'system.inputContent': 'Please enter content',
  'system.inputContentEn': 'Please enter content (English)',
  'system.inputContentCn': 'Please enter content (French)',
  'system.inputContentArabic': 'Please enter content (Arabic)',
  'system.titleRequired': 'Title cannot be empty',
  'system.titleEnRequired': 'Title (English) cannot be empty',
  'system.titleCnRequired': 'Title (French) cannot be empty',
  'system.titleArabicRequired': 'Title (Arabic) cannot be empty',
  'system.contentRequired': 'Content cannot be empty',
  'system.contentEnRequired': 'Content (English) cannot be empty',
  'system.contentCnRequired': 'Content (French) cannot be empty',
  'system.contentArabicRequired': 'Content (Arabic) cannot be empty',
  'system.normal': 'Normal',
  'system.configName': 'Config Name',
  'system.configKey': 'Config Key',
  'system.configGroup': 'Config Group',
  'system.configType': 'Config Type',
  'system.configValue': 'Config Value',
  'system.configValueEn': 'Config Value (English)',
  'system.configValueCn': 'Config Value (French)',
  'system.configValueArabic': 'Config Value (Arabic)',
  'system.configTypeInput': 'Input',
  'system.configTypeTextarea': 'Textarea',
  'system.configTypeRichText': 'Rich Text',
  'system.configTypeImage': 'Image',
  'system.addConfig': 'Add Config',
  'system.editConfig': 'Edit Config',
  'system.configNameRequired': 'Config name is required',
  'system.configGroupRequired': 'Config group is required',
  'system.configKeyRequired': 'Config key is required',
  'system.configValueRequired': 'Config value is required',
  'system.configSystem': 'System Built-in',
  'system.dictName': 'Dict Name',
  'system.dictType': 'Dict Type',
  'system.dictId': 'Dict ID',
  'system.inputDictName': 'Please enter dict name',
  'system.inputDictType': 'Please enter dict type',
  'system.dictStatus': 'Dict Status',
  'system.deptName': 'Dept Name',
  'system.refreshCache': 'Refresh Cache',
  'system.refreshSuccess': 'Refresh Success',

  // Dict labels (backend dictLabel is Chinese)
  'dict.sysCommonStatus.success': 'Success',
  'dict.sysCommonStatus.fail': 'Failed',
  'dict.sysOperType.other': 'Other',
  'dict.sysOperType.insert': 'Insert',
  'dict.sysOperType.update': 'Update',
  'dict.sysOperType.delete': 'Delete',
  'dict.sysOperType.grant': 'Grant',
  'dict.sysOperType.export': 'Export',
  'dict.sysOperType.import': 'Import',
  'dict.sysOperType.forceLogout': 'Force Logout',
  'dict.sysOperType.genCode': 'Generate Code',
  'dict.sysOperType.clean': 'Clear Data',

  // Monitor - operlog
  'monitor.operlog.systemModule': 'System Module',
  'monitor.operlog.inputSystemModule': 'Please enter system module',
  'monitor.operlog.operName': 'Operator',
  'monitor.operlog.inputOperName': 'Please enter operator',
  'monitor.operlog.filterType': 'Type',
  'monitor.operlog.businessTypePlaceholder': 'Operation type',
  'monitor.operlog.statusPlaceholder': 'Operation status',
  'monitor.operlog.operTime': 'Operation Time',
  'monitor.operlog.operId': 'Log ID',
  'monitor.operlog.businessType': 'Operation Type',
  'monitor.operlog.requestMethod': 'Request Method',
  'monitor.operlog.host': 'Host',
  'monitor.operlog.operLocation': 'Location',
  'monitor.operlog.operStatus': 'Status',
  'monitor.operlog.operDate': 'Operation Date',
  'monitor.operlog.detail': 'Details',
  'monitor.operlog.clean': 'Clear All',
  'monitor.operlog.confirmDeleteContent': 'Selected log ID(s): {ids}',
  'monitor.operlog.confirmClean': 'Clear all operation logs?',
  'monitor.operlog.confirmCleanContent': 'This will remove all operation log records.',
  'monitor.operlog.cleanSuccess': 'Cleared successfully',
  'monitor.operlog.viewOperInfo': 'Operation Details',
  'monitor.operlog.operModule': 'Module',
  'monitor.operlog.loginInfo': 'Login Info',
  'monitor.operlog.requestUrl': 'Request URL',
  'monitor.operlog.operMethod': 'Method',
  'monitor.operlog.apiInfo': 'API Details',
  'monitor.operlog.requestParam': 'Request Params',
  'monitor.operlog.responseParam': 'Response',
  'monitor.operlog.errorMsg': 'Error Message',
  'monitor.operlog.statusNormal': 'Success',
  'monitor.operlog.statusFail': 'Failed',
  'monitor.operlog.titleDailyActivity': 'Daily Active Statistics',
  'monitor.operlog.titleConfig': 'Parameter Settings',
  'monitor.operlog.titleNotice': 'Notice',
  'monitor.operlog.titleVideoAdd': 'Add Short Drama',
  'monitor.operlog.titleVideoEdit': 'Edit Short Drama',
  'monitor.operlog.titleVideoDelete': 'Delete Short Drama',
  'monitor.operlog.titleVideoExport': 'Export Short Drama',
  'monitor.operlog.titleVideoImport': 'Import Video',
  'monitor.operlog.titleUserExport': 'Export User List',
  'monitor.operlog.titleToggleStatus': 'Toggle Status',
  'monitor.operlog.titleVideoSort': 'Edit Sort Order',
  'monitor.operlog.titleHelpAdd': 'Add Help Article',
  'monitor.operlog.titleHelpEdit': 'Edit Help Article',
  'monitor.operlog.titleHelpDelete': 'Delete Help Article',
  'monitor.operlog.titleMobileCodeAdd': 'Add Area Code',
  'monitor.operlog.titleMobileCodeEdit': 'Edit Area Code',
  'monitor.operlog.titleMobileCodeDelete': 'Delete Area Code',
  'monitor.operlog.titleMobileCodeExport': 'Export Area Code',
  'monitor.operlog.titleGuideAdd': 'Add Guide Page',
  'monitor.operlog.titleGuideEdit': 'Edit Guide Page',
  'monitor.operlog.titleGuideDelete': 'Delete Guide Page',
  'monitor.operlog.titleGuideExport': 'Export Guide Page',
  'monitor.operlog.titleAvatarAdd': 'Add Avatar',
  'monitor.operlog.titleAvatarEdit': 'Edit Avatar',
  'monitor.operlog.titleAvatarDelete': 'Delete Avatar',
  'monitor.operlog.titleAvatarExport': 'Export Avatar',
  'monitor.operlog.titleWordsAdd': 'Add Sensitive Word',
  'monitor.operlog.titleWordsEdit': 'Edit Sensitive Word',
  'monitor.operlog.titleWordsDelete': 'Delete Sensitive Word',
  'monitor.operlog.titleWordsExport': 'Export Sensitive Word',
  'monitor.operlog.titleAdAdd': 'Add Advertisement',
  'monitor.operlog.titleAdEdit': 'Edit Advertisement',
  'monitor.operlog.titleAdDelete': 'Delete Advertisement',
  'monitor.operlog.titleAdExport': 'Export Advertisement',
  'monitor.operlog.titleVipOrder': 'VIP Order',
  'monitor.operlog.titleVipBind': 'Bind VIP User',
  'monitor.operlog.titleRechargeOrder': 'Recharge Order',
  'monitor.operlog.titleRechargeAdd': 'Add Recharge Order',
  'monitor.operlog.titleRechargeEdit': 'Edit Recharge Order',
  'monitor.operlog.titleRechargeDelete': 'Delete Recharge Order',
  'monitor.operlog.titleInviteRewardAdd': 'Add Invite Reward Config',
  'monitor.operlog.titleInviteRewardEdit': 'Edit Invite Reward Config',
  'monitor.operlog.titleProblemAdd': 'Add FAQ',
  'monitor.operlog.titleProblemEdit': 'Edit FAQ',
  'monitor.operlog.titleProblemStatus': 'Edit FAQ Status',
  'monitor.operlog.titleProblemDelete': 'Delete FAQ',
  'monitor.operlog.titleProblemExport': 'Export FAQ',
  'monitor.operlog.titlePerformerAdd': 'Add Performer',
  'monitor.operlog.titlePerformerEdit': 'Edit Performer',
  'monitor.operlog.titlePerformerDelete': 'Delete Performer',
  'monitor.operlog.titleUserDailyActivity': 'User Daily Active Statistics',

  // Monitor - logininfor
  'monitor.logininfor.loginAddress': 'Login IP',
  'monitor.logininfor.inputLoginAddress': 'Please enter login IP',
  'monitor.logininfor.useStatus': 'Status',
  'monitor.logininfor.loginName': 'Login Name',
  'monitor.logininfor.inputLoginName': 'Please enter login name',
  'monitor.logininfor.loginTime': 'Login Time',
  'monitor.logininfor.infoId': 'Access ID',
  'monitor.logininfor.userName': 'Username',
  'monitor.logininfor.loginLocation': 'Location',
  'monitor.logininfor.unknownLocation': 'Unknown',
  'monitor.logininfor.browser': 'Browser',
  'monitor.logininfor.os': 'OS',
  'monitor.logininfor.operMsg': 'Message',
  'monitor.logininfor.unlock': 'Unlock',
  'monitor.logininfor.confirmDeleteContent': 'Selected access ID(s): {ids}',
  'monitor.logininfor.confirmClean': 'Clear all login logs?',
  'monitor.logininfor.confirmCleanContent': 'This will remove all login log records.',
  'monitor.logininfor.confirmUnlock': 'Unlock user: {username}?',
  'monitor.logininfor.unlockSuccess': 'Unlocked successfully',

  // Monitor - server
  'monitor.server.cpu': 'CPU',
  'monitor.server.memory': 'Memory',
  'monitor.server.cpuNum': 'Cores',
  'monitor.server.cpuUsed': 'User Usage',
  'monitor.server.cpuSys': 'System Usage',
  'monitor.server.cpuFree': 'Idle',
  'monitor.server.serverInfo': 'Server Information',
  'monitor.server.computerName': 'Server Name',
  'monitor.server.osName': 'Operating System',
  'monitor.server.computerIp': 'Server IP',
  'monitor.server.osArch': 'Architecture',
  'monitor.server.jvmInfo': 'JVM Information',
  'monitor.server.javaName': 'Java Name',
  'monitor.server.javaVersion': 'Java Version',
  'monitor.server.startTime': 'Start Time',
  'monitor.server.runTime': 'Uptime',
  'monitor.server.installPath': 'Install Path',
  'monitor.server.projectPath': 'Project Path',
  'monitor.server.runArgs': 'JVM Arguments',
  'monitor.server.diskStatus': 'Disk Status',
  'monitor.server.attr': 'Attribute',
  'monitor.server.memColumn': 'Memory',
  'monitor.server.dirPath': 'Drive Path',
  'monitor.server.fileSystem': 'File System',
  'monitor.server.diskType': 'Drive Type',
  'monitor.server.totalSize': 'Total',
  'monitor.server.freeSize': 'Free',
  'monitor.server.usedSize': 'Used',
  'monitor.server.usagePercent': 'Usage %',
  'monitor.server.mem.total': 'Total Memory',
  'monitor.server.mem.used': 'Used Memory',
  'monitor.server.mem.free': 'Free Memory',
  'monitor.server.mem.usage': 'Usage',

  // Monitor - cache
  'monitor.cache.basicInfo': 'Basic Information',
  'monitor.cache.redisVersion': 'Redis Version',
  'monitor.cache.runMode': 'Run Mode',
  'monitor.cache.standalone': 'Standalone',
  'monitor.cache.cluster': 'Cluster',
  'monitor.cache.port': 'Port',
  'monitor.cache.clients': 'Clients',
  'monitor.cache.uptimeDays': 'Uptime (days)',
  'monitor.cache.usedMemory': 'Used Memory',
  'monitor.cache.usedCpu': 'CPU Usage',
  'monitor.cache.memoryConfig': 'Memory Config',
  'monitor.cache.aofEnabled': 'AOF Enabled',
  'monitor.cache.rdbStatus': 'RDB Status',
  'monitor.cache.keyCount': 'Key Count',
  'monitor.cache.networkKps': 'Network I/O',
  'monitor.cache.commandStats': 'Command Statistics',
  'monitor.cache.memoryInfo': 'Memory Information',
  'monitor.cache.chartCommand': 'Commands',
  'monitor.cache.chartPeak': 'Peak',
  'monitor.cache.chartMemoryConsumption': 'Memory Usage',

  // Monitor - cache list
  'monitor.cacheList.cacheList': 'Cache List',
  'monitor.cacheList.keyList': 'Key List',
  'monitor.cacheList.cacheContent': 'Cache Content',
  'monitor.cacheList.cacheName': 'Cache Name',
  'monitor.cacheList.cacheKey': 'Cache Key',
  'monitor.cacheList.cacheValue': 'Cache Value',
  'monitor.cacheList.confirmClearAll': 'Clear all cache?',
  'monitor.cacheList.confirmDelete': 'Delete cache "{name}"?',
  'monitor.cacheList.refreshNamesSuccess': 'Cache list refreshed',
  'monitor.cacheList.clearNameSuccess': 'Cache name [{name}] cleared',
  'monitor.cacheList.refreshKeysSuccess': 'Key list refreshed',
  'monitor.cacheList.clearKeySuccess': 'Cache key [{key}] cleared',
  'monitor.cacheList.clearAllSuccess': 'All cache cleared',

  // Menu labels for internationalization
  'menu.videoManagement': 'Video Management',
  'menu.videoList': 'Video List',
  'menu.barrageManagement': 'Barrage Management',
  'menu.publicizeManagement': 'Publicize Management',
  'menu.sensitiveWordManagement': 'Sensitive Word Management',
  'menu.videoCategoryManagement': 'Video Category Management',
  'menu.userBuyVideoList': 'User Buy Video List',
  'menu.userManagement': 'User Management',
  'menu.userInfo': 'User Info',
  'menu.userWithdraw': 'User Withdraw',
  'menu.userFeedback': 'User Feedback',
  'menu.userCancelManagement': 'User Cancel Management',
  'menu.userReport': 'User Report',
  'menu.userRights': 'User Rights',
  'menu.exchangeCode': 'Exchange Code',
  'menu.referralRewardConfig': 'Referral Reward Config',
  'menu.vipPurchaseList': 'VIP Purchase List',
  'menu.signConfig': 'Sign Config',
  'menu.taskRewardManagement': 'Task Reward Management',
  'menu.rechargeManagement': 'Recharge Management',
  'menu.rechargeMenuManagement': 'Recharge Menu Management',
  'menu.vipMenuManagement': 'VIP Menu Management',
  'menu.resourcePositionConfig': 'Resource Position Config',
  'menu.urlManagement': 'URL Management',
  'menu.helpCenter': 'Help Center',
  'menu.guidePage': 'Guide Page',
  'menu.distributionConfig': 'Distribution Config',
  'menu.carouselManagement': 'Carousel Management',
  'menu.searchWordManagement': 'Search Word Management',
  'menu.avatarManagement': 'Avatar Management',
  'menu.tabbarManagement': 'Tabbar Management',
  'menu.mobileCodeManagement': 'Mobile Code Management',
  'menu.financialReport': 'Financial Report',
  'menu.videoReport': 'Video Report',
  'menu.coinRechargeOrderList': 'Coin Recharge Order List',
  'menu.versionUpdate': 'Version Update',
  'menu.versionManagement': 'Version Management',
  'menu.systemManagement': 'System Management',
  'menu.userQuery': 'User Query',
  'menu.userAdd': 'User Add',
  'menu.userEdit': 'User Edit',
  'menu.userDelete': 'User Delete',
  'menu.userExport': 'User Export',
  'menu.userImport': 'User Import',
  'menu.resetPassword': 'Reset Password',
  'menu.roleManagement': 'Role Management',
  'menu.roleQuery': 'Role Query',
  'menu.roleAdd': 'Role Add',
  'menu.roleEdit': 'Role Edit',
  'menu.roleDelete': 'Role Delete',
  'menu.maskPermission': 'Mask Permission',
  'menu.menuManagement': 'Menu Management',
  'menu.menuQuery': 'Menu Query',
  'menu.menuAdd': 'Menu Add',
  'menu.menuEdit': 'Menu Edit',
  'menu.menuDelete': 'Menu Delete',
  'menu.paramSettings': 'Param Settings',
  'menu.paramQuery': 'Param Query',
  'menu.paramAdd': 'Param Add',
  'menu.paramEdit': 'Param Edit',
  'menu.paramDelete': 'Param Delete',
  'menu.paramExport': 'Param Export',
  'menu.noticeAnnouncement': 'Notice Announcement',
  'menu.noticeQuery': 'Notice Query',
  'menu.noticeAdd': 'Notice Add',
  'menu.noticeEdit': 'Notice Edit',
  'menu.noticeDelete': 'Notice Delete',
  'menu.logManagement': 'Log Management',
  'menu.operationLog': 'Operation Log',
  'menu.operationQuery': 'Operation Query',
  'menu.operationDelete': 'Operation Delete',
  'menu.logExport': 'Log Export',
  'menu.loginLog': 'Login Log',
  'menu.loginQuery': 'Login Query',
  'menu.loginDelete': 'Login Delete',
  'menu.accountUnlock': 'Account Unlock',
  'menu.systemTools': 'System Tools',
  'menu.formBuilder': 'Form Builder',
  'menu.codeGeneration': 'Code Generation',
  'menu.generateQuery': 'Generate Query',
  'menu.generateEdit': 'Generate Edit',
  'menu.generateDelete': 'Generate Delete',
  'menu.importCode': 'Import Code',
  'menu.previewCode': 'Preview Code',
  'menu.generateCode': 'Generate Code',
  'menu.systemInterface': 'System Interface',
  'menu.databaseDoc': 'Database Doc',
  'menu.systemMonitor': 'System Monitor',
  'menu.dataMonitor': 'Data Monitor',
  'menu.serviceMonitor': 'Service Monitor',
  'menu.cacheMonitor': 'Cache Monitor',
  'menu.cacheList': 'Cache List',

  // User related - login and register
  'user.account': 'Account',
  'user.password': 'Password',
  'user.confirmPassword': 'Confirm Password',
  'user.captcha': 'Captcha',
  'user.rememberPassword': 'Remember Password',
  'user.confirm': 'Confirm',
  'user.register': 'Register',
  'user.login': 'Login',
  'user.useExistingAccount': 'Login with existing account',
  'user.loginFailed': 'Login failed, please check account and password',
  'user.welcome': 'Welcome',
  'user.welcomeBack': 'Welcome back',
  'user.registerSuccess': 'Congratulations! Your account {username} has been registered successfully!',
  'user.inputAccount': 'Please enter account name',
  'user.inputPassword': 'Please enter password',
  'user.inputCaptcha': 'Please enter captcha',
  'user.inputNewPassword': 'Please enter new password',
  'user.inputNewPasswordRule': 'Please enter 5-20 English letters, numbers or symbols (except spaces), and at least two of letters, numbers and punctuation',
  'user.inputConfirmPassword': 'Please enter new password again to confirm',
  'user.passwordNotMatch': 'The two passwords do not match',
  'user.inputAccountName': 'Please enter your account',
  'user.accountLength': 'Account length must be between 2 and 20',
  'user.inputYourPassword': 'Please enter your password',
  'user.inputPasswordAgain': 'Please enter your password again',

  // User related - disposition
  'user.disposition.title': 'Title',
  'user.disposition.isOpen': 'Is Open',
  'user.disposition.sort': 'Sort',
  'user.disposition.inputIsOpen': 'Please enter is open',
  'user.disposition.inputSort': 'Please enter sort',
  'user.disposition.content': 'Content',
  'user.disposition.config': 'Config',

  // User related - withdraw
  'user.withdraw.nickname': 'Nickname',
  'user.withdraw.email': 'Email',
  'user.withdraw.mobile': 'Mobile',
  'user.withdraw.status': 'Status',
  'user.withdraw.statusPending': 'Pending',
  'user.withdraw.statusRejected': 'Rejected',
  'user.withdraw.statusApproved': 'Approved Not Paid',
  'user.withdraw.statusPaid': 'Paid',
  'user.withdraw.money': 'Withdraw Amount',
  'user.withdraw.realMoney': 'Real Transfer Amount',
  'user.withdraw.serviceCharge': 'Service Charge',
  'user.withdraw.type': 'Withdraw Type',
  'user.withdraw.typePaypal': 'Paypal',
  'user.withdraw.typeBank': 'Bank Card',
  'user.withdraw.typeAlipay': 'Alipay',
  'user.withdraw.auditOpinion': 'Audit Opinion',
  'user.withdraw.applyTime': 'Apply Time',
  'user.withdraw.audit': 'Audit',
  'user.withdraw.exportFileName': 'User Withdraw Record',
  'user.withdraw.none': 'None',

  // User related - koc
  'user.koc.code': 'Redeem Code',
  'user.koc.userNickname': 'User Nickname',
  'user.koc.useTime': 'Used Time',
  'user.koc.inputCode': 'Please enter redeem code',
  'user.koc.type': 'Type',
  'user.koc.goldCard': 'Gold Card',
  'user.koc.vipCard': 'VIP Card',
  'user.koc.typeGold': 'Gold Card',
  'user.koc.typeVip': 'VIP Card',
  'user.koc.goldAmount': 'Gold Amount',
  'user.koc.vipDays': 'VIP Days',
  'user.koc.numberValue': 'Gold Amount/VIP Days',
  'user.koc.goldAmountOrVipDays': 'Gold Amount / VIP Days',
  'user.koc.useStatus': 'Usage Status',
  'user.koc.isUsed': 'Used',
  'user.koc.statusUsed': 'Used',
  'user.koc.statusUnused': 'Unused',
  'user.koc.addAmount': 'Add Quantity',
  'user.koc.userIdRequired': 'User ID cannot be empty',

  // User related - userAvatar
  'user.userAvatar.avatarLink': 'Avatar Link',
  'user.userAvatar.exportFileName': 'User Avatar',

  'common.more': 'More',
  // User related - distribution
  'user.distribution.type': 'Type',
  'user.distribution.typeRatio': 'Gift Ratio',
  'user.distribution.typeAmount': 'Gift Amount',
  'user.distribution.description': 'Description',
  'user.distribution.amount': 'Amount',
  'user.distribution.exportFileName': 'Distribution Config',
  'user.distribution.inputDescription': 'Please enter description',
  'user.distribution.inputAmount': 'Please enter amount',
  'user.distribution.value': 'Value',

  // User related - withdraw
  'user.withdraw.realMoney': 'Real Transfer Amount',
  'user.withdraw.withdrawType': 'Withdraw Type',
  'user.withdraw.paypal': 'Paypal',
  'user.withdraw.bankCard': 'Bank Card',
  'user.withdraw.alipay': 'Alipay',
  'user.withdraw.securityCode': 'Security Code',
  'user.withdraw.cardNumber': 'Card Number',
  'user.withdraw.cardholderName': 'Cardholder Name',
  'user.withdraw.bankName': 'Bank Name',
  'user.withdraw.bankCardNumber': 'Bank Card Number',
  'user.withdraw.bankAccount': 'Bank Account',
  'user.withdraw.alipayQRCode': 'Alipay QR Code',
  'user.withdraw.noQRCode': 'No QR Code',
  'user.withdraw.realName': 'Real Name',
  'user.withdraw.auditOpinion': 'Audit Opinion',
  'user.withdraw.inputAuditOpinion': 'Please enter audit opinion',
  'user.withdraw.rejected': 'Rejected',
  'user.withdraw.approved': 'Approved',
  'user.withdraw.paid': 'Paid',

  // User related - userAvatar
  'user.userAvatar.avatarLinkRequired': 'Avatar link cannot be empty',
  'user.userAvatar.operationSuccess': 'Operation Success!',

  // User related - disposition
  'user.disposition.inputContent': 'Please enter content',
  'user.disposition.arabicContentRequired': 'Arabic content cannot be empty',
  'user.disposition.isOpenRequired': 'Is open cannot be empty',

  // User related - withdraw
  'user.withdraw.audit': 'Audit',
  'user.withdraw.userIdRequired': 'User ID cannot be empty',
  'user.withdraw.moneyRequired': 'Withdraw amount cannot be empty',
  'user.withdraw.statusRequired': 'Status cannot be empty',
  'user.withdraw.withdrawTypeRequired': 'Withdraw type cannot be empty',
  'user.withdraw.withdrawUserTypeRequired': 'Withdraw user type cannot be empty',

  // VIP related - menu
  'vip.menu.unitPrice': 'Unit Price Per Day',
  'vip.menu.inputUnitPrice': 'Please enter unit price per day',
  'vip.menu.totalPrice': 'Total Price',
  'vip.menu.inputTotalPrice': 'Please enter total price',
  'vip.menu.remark': 'Remark',
  'vip.menu.inputRemark': 'Please enter remark',
  'vip.menu.remarkEn': 'Remark (English)',
  'vip.menu.inputRemarkEn': 'Please enter remark (English)',
  'vip.menu.remarkCn': 'Remark (French)',
  'vip.menu.inputRemarkCn': 'Please enter remark (French)',
  'vip.menu.remarkArabic': 'Remark (Arabic)',
  'vip.menu.inputRemarkArabic': 'Please enter remark (Arabic)',
  'vip.menu.type': 'Type',
  'vip.menu.typeWeek': 'Weekly Member',
  'vip.menu.typeMonth': 'Monthly Member',
  'vip.menu.typeYear': 'Yearly Member',
  'vip.menu.operationSuccess': 'Operation Success',
  'vip.menu.exportFileName': 'VIP Menu',
  'vip.menu.typeRequired': 'Type cannot be empty',
  'vip.menu.unitPriceRequired': 'Unit price per day cannot be empty',
  'vip.menu.totalPriceRequired': 'Total price cannot be empty',

  // VIP related - order
  'vip.order.nickName': 'Nickname',
  'vip.order.inputNickName': 'Please enter nickname',
  'vip.order.mobile': 'Mobile',
  'vip.order.inputMobile': 'Please enter mobile',
  'vip.order.email': 'Email',
  'vip.order.inputEmail': 'Please enter email',
  'vip.order.orderNo': 'Order No',
  'vip.order.inputOrderNo': 'Please enter order no',
  'vip.order.payTime': 'Pay Time',
  'vip.order.payMoney': 'Pay Amount ($)',
  'vip.order.inputPayMoney': 'Please enter pay amount',
  'vip.order.payNo': 'Pay No',
  'vip.order.inputPayNo': 'Please enter pay no',
  'vip.order.outTrandNo': 'Third Party Order No',
  'vip.order.inputOutTrandNo': 'Please enter third party order no',
  'vip.order.menuId': 'Menu ID',
  'vip.order.inputMenuId': 'Please enter menu ID',
  'vip.order.status': 'Status',
  'vip.order.statusPending': 'Pending',
  'vip.order.statusSuccess': 'Success',
  'vip.order.statusFailed': 'Failed',
  'vip.order.exportFileName': 'VIP Order',
  'vip.order.userIdRequired': 'User ID cannot be empty',
  'vip.order.orderNoRequired': 'Order No cannot be empty',
  'vip.order.payMoneyRequired': 'Pay amount cannot be empty',
  'vip.order.statusRequired': 'Status cannot be empty',

  // Zhuima related - taskConfig
  'zhuima.taskConfig.facebookNum': 'Follow Facebook Account Reward Coins',
  'zhuima.taskConfig.inputFacebookNum': 'Please enter follow Facebook account reward coins',
  'zhuima.taskConfig.youtubeNum': 'Follow Official Account Reward Coins',
  'zhuima.taskConfig.inputYoutubeNum': 'Please enter follow official account reward coins',
  'zhuima.taskConfig.tiktok': 'Follow Tiktok Account Reward Coins',
  'zhuima.taskConfig.inputTiktok': 'Please enter follow Tiktok account reward coins',
  'zhuima.taskConfig.openMessage': 'Open Message Notification Reward Coins',
  'zhuima.taskConfig.inputOpenMessage': 'Please enter open message notification reward coins',
  'zhuima.taskConfig.likeNum': 'Fill Interests Reward Coins',
  'zhuima.taskConfig.inputLikeNum': 'Please enter fill interests reward coins',
  'zhuima.taskConfig.lookVideoOne': 'Watch 5 Minutes Reward Coins',
  'zhuima.taskConfig.inputLookVideoOne': 'Please enter watch 5 minutes reward coins',
  'zhuima.taskConfig.lookVideoTwo': 'Watch 10 Minutes Reward Coins',
  'zhuima.taskConfig.inputLookVideoTwo': 'Please enter watch 10 minutes reward coins',
  'zhuima.taskConfig.advertisementNum': 'Watch One Ad Reward Coins',
  'zhuima.taskConfig.inputAdvertisementNum': 'Please enter watch one ad reward coins',
  'zhuima.taskConfig.maxAdvertisementNum': 'Max Ads Per Day',
  'zhuima.taskConfig.inputMaxAdvertisementNum': 'Please enter max ads per day',
  'zhuima.taskConfig.exportFileName': 'Task Reward Config',

  // Zhuima related - userPrize
  'zhuima.userPrize.prizeName': 'Prize Name',
  'zhuima.userPrize.inputPrizeName': 'Please enter prize name',
  'zhuima.userPrize.prizeCover': 'Prize Cover',
  'zhuima.userPrize.openTime': 'Draw Time',
  'zhuima.userPrize.useFlag': 'Use Flag',
  'zhuima.userPrize.useFlagUnused': 'Unused',
  'zhuima.userPrize.useFlagUsed': 'Used',
  'zhuima.userPrize.prizeId': 'Prize ID',
  'zhuima.userPrize.inputPrizeId': 'Please enter prize ID',
  'zhuima.userPrize.address': 'Address',
  'zhuima.userPrize.inputAddress': 'Please enter address',
  'zhuima.userPrize.exportFileName': 'User Prize Record',
  'zhuima.userPrize.useFlagLabel': 'Use Flag 0-Unused 1-Used',
  'zhuima.userPrize.inputUseFlag': 'Please enter use flag 0-unused 1-used',

  // Zhuima related - taskUser
  'zhuima.taskUser.facebookNum': 'Follow Facebook Reward Coins',
  'zhuima.taskUser.inputFacebookNum': 'Please enter follow Facebook reward coins',
  'zhuima.taskUser.isFackbook': 'Is Follow Facebook',
  'zhuima.taskUser.inputIsFackbook': 'Please enter is follow Facebook',
  'zhuima.taskUser.youtubeNum': 'Follow Youtube Reward Coins',
  'zhuima.taskUser.inputYoutubeNum': 'Please enter follow Youtube reward coins',
  'zhuima.taskUser.isYoutube': 'Is Follow Youtube',
  'zhuima.taskUser.inputIsYoutube': 'Please enter is follow Youtube',
  'zhuima.taskUser.tiktok': 'Follow Tiktok Reward Coins',
  'zhuima.taskUser.inputTiktok': 'Please enter follow Tiktok reward coins',
  'zhuima.taskUser.isTiktok': 'Is Follow Tiktok',
  'zhuima.taskUser.inputIsTiktok': 'Please enter is follow Tiktok',
  'zhuima.taskUser.openMessage': 'Open Message Notification Reward Coins',
  'zhuima.taskUser.inputOpenMessage': 'Please enter open message notification reward coins',
  'zhuima.taskUser.isOpen': 'Is Open Message Notification',
  'zhuima.taskUser.inputIsOpen': 'Please enter is open message notification',
  'zhuima.taskUser.likeNum': 'Set Interests Reward Coins',
  'zhuima.taskUser.inputLikeNum': 'Please enter set interests reward coins',
  'zhuima.taskUser.isLike': 'Is Set Interests',
  'zhuima.taskUser.inputIsLike': 'Please enter is set interests',
  'zhuima.taskUser.exportFileName': 'Task Reward User Record',

  // Zhuima related - prize
  'zhuima.prize.prizeName': 'Prize Name',
  'zhuima.prize.inputPrizeName': 'Please enter prize name',
  'zhuima.prize.prizeCover': 'Prize Cover',
  'zhuima.prize.probability': 'Probability',
  'zhuima.prize.inputProbability': 'Please enter probability',
  'zhuima.prize.isBan': 'Is Ban',
  'zhuima.prize.prizeType': 'Prize Type',
  'zhuima.prize.prizeTypeVip': 'VIP',
  'zhuima.prize.prizeTypePhysical': 'Physical Prize',
  'zhuima.prize.vipDays': 'VIP Days',
  'zhuima.prize.inputVipDays': 'Please enter VIP days',
  'zhuima.prize.exportFileName': 'Prize',
  'zhuima.prize.operationSuccess': 'Operation Success',
  'zhuima.prize.upload': 'Upload',
  'zhuima.prize.selectPrizeType': 'Please select prize type',

  // Help related
  'help.title': 'Title',
  'help.titleEn': 'Title (English)',
  'help.titleCn': 'Title (French)',
  'help.titleIn': 'Title (Indonesian)',
  'help.content': 'Content',
  'help.contentEn': 'Content (English)',
  'help.contentCn': 'Content (French)',
  'help.contentIn': 'Content (Indonesian)',
  'help.sort': 'Sort',
  'help.createTime': 'Create Time',
  'help.inputTitle': 'Please enter title',
  'help.inputTitleEn': 'Please enter title (English)',
  'help.inputTitleCn': 'Please enter title (French)',
  'help.inputTitleIn': 'Please enter title (Arabic)',
  'help.inputContent': 'Please enter content',
  'help.inputSort': 'Please enter sort',
  'help.titleRequired': 'Title cannot be empty',
  'help.sortRequired': 'Sort cannot be empty',
  'help.add': 'Add',
  'help.edit': 'Edit',
  'help.exportFileName': 'Help Center',

  // App title
  'app.title': 'Laqta',

  // Account dropdown
  'account.personalSettings': 'Personal Settings',
  'account.logout': 'Logout',
  'account.logoutTitle': 'Tip',
  'account.confirmLogout': 'Are you sure you want to logout?'
}

